import { render, staticRenderFns } from "./PlaceholderPage.vue?vue&type=template&id=18180708"
import script from "./PlaceholderPage.vue?vue&type=script&lang=js"
export * from "./PlaceholderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports